import React from "react";
import { useQuery } from "react-query";
import { useClient } from "hooks";
import { NotificationManager } from "react-notifications";
import { useRouter } from "hooks";
import { isEmpty } from "lodash";
import {Editor, FormGroup, ImageUpload, Page, Select, SubmitButton} from "components/common";
import {Field, FormikProvider, useFormik} from "formik";
import {isFloat} from "validator";

export const TeamEdit = () => {
  const client = useClient();
  const { match, history } = useRouter();
  const { id } = match.params;
  const formik = useFormik({
    onSubmit,
    initialValues: {}
  })
  const { handleSubmit, setValues, values } = formik;

  const url = "team";

  const { data: sections } = useQuery(['team_sections'], args => client.get(args).get('data'));

  const { refetch } = useQuery(
    [`${url}/${id}`],
    args => client.get(args).get("data"),
    {
      onSuccess: (values) => setValues(values),
    }
  );

  async function onSubmit(x) {
    const { id: _id } = await (
      x.id ? client.put(`${url}/${x.id}`, x) : client.post(url, x)
    ).get('data');
    NotificationManager.success("Team member successfully saved");

    if (id === `${_id}`) {
      await refetch({ throwOnError: true });
    } else {
      history.replace(match.path.replace(":id", _id));
    }
  }

  if (isEmpty(values)) return null;

  return (
    <Page title="Team Member">
      <FormikProvider value={formik}>
        <form noValidate onSubmit={handleSubmit}>
          <FormGroup name="name" label="Name">
            <Field name="name" className="form-control" validate={(v) => !v} />
          </FormGroup>
          <FormGroup name="job_title" label="Job title">
            <Field name="job_title" className="form-control" validate={(v) => !v} />
          </FormGroup>
          <FormGroup name="section" label="Section">
            <Field
              name="section"
              component={Select}
              options={sections}
              simpleValue
              labelKey="name"
              valueKey="id"
              validate={v => !v}
            />
          </FormGroup>
          <FormGroup name="image" label="Image">
            <Field component={ImageUpload} name="image" validate={(v) => {
              if (values.id) return false;
              return !v;
            }} />
          </FormGroup>
          <FormGroup name="order" label="Order">
            <Field name="order" className="form-control" validate={(v) => !isFloat(v + "")} />
          </FormGroup>
          <FormGroup name="description" label="Description">
            <Field component={Editor} name="description" validate={v => !v} />
          </FormGroup>
          <div className="tw-flex tw-justify-end">
            <SubmitButton>Save</SubmitButton>
          </div>
        </form>
      </FormikProvider>
    </Page>
  );
};
